module.exports = __webpack_public_path__ + "static/banner-assurances-desktop-55cc03d9883051d51fa3c7bc95a79b1d.jpg";